import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-amiante',
    templateUrl: './amiante.component.html',
    styleUrls: ['./amiante.component.css'],
    standalone: false
})
export class AmianteComponent implements OnInit {

  @Input() chantier;
  @Input() edit: Boolean;
  @Input() hidetitle: Boolean;
  resultEntreprise: any[] = [];
  resultMaitre: any[] = [];
  entreprise = '';
  maitreOuvrage = '';

  constructor(public common: CommonService) { }

  ngOnInit() {
    this.maitreOuvrage = this.chantier['maitreOuvrage'] ? `${this.chantier['maitreOuvrage'].codeClient ?
      this.chantier['maitreOuvrage'].codeClient + '/' : ''}${this.chantier['maitreOuvrage'].nomClient || ''}` : '';
    this.entreprise = this.chantier['entrepriseTravaux'] ? `${this.chantier['entrepriseTravaux'].codeClient ?
      this.chantier['entrepriseTravaux'].codeClient + '/' : ''}${this.chantier['entrepriseTravaux'].nomClient || ''}` : '';
  }

  searchEntreprise(event) {
    const requette = 11;

    return this.common.appelComboK3Fct(requette, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.resultEntreprise = datas.data;
      }
    });
  }

  searchMaitre(event) {
    const requette = 12;

    return this.common.appelComboK3Fct(requette, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.resultMaitre = datas.data;
      }
    });
  }

}
